<template>
  <div class="page-shell">
    <HeroCarousel :slides="heroSlides" />
    <ProductMenuGrid :items="productCategories" />
    <AboutShowcase :stats="companyStats" />
    <SolutionCarousel />
    <NewsTabsCarousel :source-tabs="newsTabs" />
    <PartnerWorldMap />
  </div>
</template>

<script>
import HeroCarousel from "../../components/home/HeroCarousel.vue";
import ProductMenuGrid from "../../components/home/ProductMenuGrid.vue";
import AboutShowcase from "../../components/home/AboutShowcase.vue";
import SolutionCarousel from "../../components/home/SolutionCarousel.vue";
import NewsTabsCarousel from "../../components/home/NewsTabsCarousel.vue";
import PartnerWorldMap from "../../components/home/PartnerWorldMap.vue";
import { getNewsTabs } from "../../data/news";
import {
  heroSlides,
  productCategories,
  companyStats
} from "../../data/site";

export default {
  name: "HomePage",
  components: {
    HeroCarousel,
    ProductMenuGrid,
    AboutShowcase,
    SolutionCarousel,
    NewsTabsCarousel,
    PartnerWorldMap
  },
  data() {
    return {
      heroSlides,
      productCategories,
      companyStats,
      newsTabs: getNewsTabs()
    };
  }
};
</script>
